import _extends from "@babel/runtime/helpers/extends";
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Treebeard } from 'react-treebeard';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Icon from '../Icon';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Tree');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "chevron",
  size: "small"
});
const Tree = _ref => {
  let {
    overrides: overridesProp,
    id,
    classes: classesProp,
    onToggle,
    onSelect,
    nodes,
    customs,
    canSelectParents
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const [data, setData] = useState(nodes);
  const [cursor, setCursor] = useState(false);
  useEffect(() => {
    setData(nodes);
  }, [nodes]);
  const override = getOverrides(overridesProp, Tree.overrides);
  const onToggleNode = useCallback((node, toggled) => {
    if (node.children) node.toggled = toggled;
    setData({
      ...data
    });
    onToggle && onToggle(node);
  }, [data, onToggle]);
  const onSelectNode = useCallback(node => {
    if (cursor) cursor.active = false;
    if (canSelectParents || !node.children || !node.children.length) node.active = true;else node.active = false;
    if (cursor && node && data.id !== node.id) data.active = false;
    setData({
      ...data
    });
    setCursor(node);
    onSelect && onSelect(node);
  }, [canSelectParents, cursor, data, onSelect]);
  const treeStyle = useMemo(() => ({
    tree: {
      base: {
        listStyle: 'none',
        background: 'transparent',
        margin: 0,
        padding: 0
      },
      node: {
        base: {
          position: 'relative'
        },
        subtree: {
          listStyle: 'none',
          paddingLeft: '19px'
        }
      }
    }
  }), []);
  const decorators = useMemo(() => ({
    Container: props => {
      if (customs.Container) return /*#__PURE__*/React.createElement(customs.Container, props);
      const isSelectable = (canSelectParents || !props.node.children || !props.node.children.length) && !props.node.isDisabled;
      const nodeClasses = classnames(classes.node, {
        ["HoiPoi__Tree__".concat(id, "__node-id-").concat(props.node.id)]: id && props.node.id,
        [classes.toggled]: props.node.toggled,
        [classes.active]: props.node.active,
        [classes.empty]: !props.node.children || !props.node.children.length,
        [classes.isDisabled]: props.node.isDisabled,
        [classes.isSelectable]: isSelectable
      });
      const NodeIcon = /*#__PURE__*/React.createElement("div", _extends({
        className: classes.nodeIcon,
        onClick: !props.node.isDisabled ? props.onClick : undefined
      }, override.nodeIcon), customs.NodeIcon ? /*#__PURE__*/React.createElement(customs.NodeIcon, props) : _ref2);
      const NodeItem = /*#__PURE__*/React.createElement("div", _extends({
        className: classes.nodeItem,
        onClick: !props.node.isDisabled ? () => onSelectNode(props.node) : undefined
      }, override.nodeItem), customs.NodeItem ? /*#__PURE__*/React.createElement(customs.NodeItem, props) : props.node.name);
      const Node = customs.Node ? /*#__PURE__*/React.createElement(customs.Node, _extends({}, props, {
        NodeIcon: NodeIcon,
        NodeItem: NodeItem
      })) : /*#__PURE__*/React.createElement("div", _extends({
        className: nodeClasses
      }, override.node), NodeIcon, NodeItem);
      return Node;
    }
  }), [customs.Container, customs.NodeIcon, customs.NodeItem, customs.Node, canSelectParents, classes.node, classes.toggled, classes.active, classes.empty, classes.isDisabled, classes.isSelectable, classes.nodeIcon, classes.nodeItem, id, override.nodeIcon, override.nodeItem, override.node, onSelectNode]);
  return /*#__PURE__*/React.createElement(Treebeard, _extends({
    data: data,
    onToggle: onToggleNode,
    decorators: decorators,
    style: treeStyle
  }, override.root));
};
Tree.overrides = ['root', 'node', 'nodeItem', 'nodeIcon'];
Tree.defaultProps = {
  nodes: {},
  customs: {}
};
process.env.NODE_ENV !== "production" ? Tree.propTypes = {
  id: PropTypes.any,
  onToggle: PropTypes.func,
  onSelect: PropTypes.func,
  nodes: PropTypes.shape({
    id: PropTypes.any,
    children: PropTypes.array,
    toggled: PropTypes.bool,
    active: PropTypes.bool,
    isSelectable: PropTypes.bool
  }),
  canSelectParents: PropTypes.bool,
  customs: PropTypes.shape({
    Container: PropTypes.func,
    Node: PropTypes.func,
    NodeIcon: PropTypes.func,
    NodeItem: PropTypes.func
  })
} : void 0;
export default /*#__PURE__*/React.memo(Tree);